import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  
  const ADMIN_EMAIL = 'petre-alexandru.dumitrescu0721@stud.umfcd.ro';
  
  // Check if user is logged in and is the admin
  if (!user || user.isGuest || user.email !== ADMIN_EMAIL) {
    return <Navigate to="/calculator" replace />;
  }
  
  return children;
};

export default AdminRoute;
